import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"
import track from "../../../components/track"

const PrivacyPolicy = () => {

  const pageTitle = 'Contact';
  const pageDescription = 'Contact';
  const pageName = "Contact";

  return (
    <Layout pageTitle={pageTitle} pageDescription={pageDescription} pageType="hcp" pageSection="hcp-contact" pageClass="contact"  pageName={pageName}>
      <div className="container">
        <h1>Contact Us</h1>
        <p>All product-specific questions and medication information requests:</p>
        <ul>
          <li>Tel: <a className="blue-link" href="tel:18779006479">1-877-900-6479</a></li>
          <li>Email: <a className="blue-link" href="mailto:averitasmc@eversana.com">averitasmc@eversana.com</a></li>
        </ul>
        <br />

        <h3>Adverse Reactions</h3>
        <p>Adverse reactions can be reported to Averitas Pharma, Inc., at <a className="blue-link" href="tel:18779006479">1-877-900-6479</a> or FDA at <a className="blue-link" href="tel:18003321088">1-800-FDA-1088</a> or <a className="blue-link" href="https://www.fda.gov/medwatch" target="_blank" rel="noopener noreferrer" id="isi-patient-fda">www.fda.gov/medwatch</a>.</p>

      </div>
    </Layout>
  )
}

export default PrivacyPolicy
